/**
 * «چند چیپ در دو سطر جا می‌شود؟» — هندسه‌ی خالص، بدونِ DOM (WHOSUP-157).
 *
 * ردیفِ دسته‌های کشفِ وب دیگر «۸ تای اول» نیست: دو سطرِ کامل است و چیپِ
 * «بیشتر» همیشه جزوشان و آخرین است. چیدنِ flex-wrap قابلِ پیش‌بینی است
 * (چپ‌به‌چپ، با فاصله‌ی ثابت)، پس همان را این‌جا شبیه‌سازی می‌کنیم تا وب
 * فقط عرض‌ها را اندازه بگیرد و بشمارد — و قاعده با `npm test` آزمودنی بماند.
 */

/**
 * بزرگ‌ترین n که چیپ‌های 0..n-1 به‌علاوه‌ی چیپِ «بیشتر» (که همیشه آخر است)
 * در `maxRows` سطرِ ظرفِ `containerWidth` جا می‌شوند.
 *
 * چیپِ پهن‌تر از خودِ ظرف، سطرِ خودش را می‌گیرد — همان کاری که flex-wrap
 * می‌کند — و عملاً یعنی همان‌جا سطر تمام می‌شود.
 */
export function fitChipRows(
  widths: readonly number[],
  moreWidth: number,
  containerWidth: number,
  gap: number,
  maxRows = 2,
): number {
  let row = 0;
  let x = 0;
  /** جای چیپِ بعدی با پهنای w؛ حالت را جلو می‌برد و سطرش را برمی‌گرداند. */
  const place = (w: number): number => {
    if (x > 0 && x + gap + w > containerWidth) {
      row += 1;
      x = w;
    } else {
      x = x > 0 ? x + gap + w : w;
    }
    return row;
  };
  /** «بیشتر» بعد از وضعِ فعلی کجا می‌افتاد — بدونِ دست زدن به حالت. */
  const moreFits = (): boolean => {
    const wraps = x > 0 && x + gap + moreWidth > containerWidth;
    return (wraps ? row + 1 : row) < maxRows;
  };

  let best = 0;
  if (!moreFits()) return 0;
  for (let i = 0; i < widths.length; i += 1) {
    if (place(widths[i]) >= maxRows) break;
    if (moreFits()) best = i + 1;
  }
  return best;
}
